import { render, staticRenderFns } from "./LmQmsTotems.vue?vue&type=template&id=ded07154&scoped=true&"
import script from "./LmQmsTotems.vue?vue&type=script&lang=js&"
export * from "./LmQmsTotems.vue?vue&type=script&lang=js&"
import style0 from "./LmQmsTotems.vue?vue&type=style&index=0&id=ded07154&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded07154",
  null
  
)

export default component.exports